
  import { mapGetters } from 'vuex';
  import { orderBy } from 'lodash';
  import { scrollToTop } from '~/scripts/utils';

  export default {
    meta: {
      jumbotronScope: 'compare-tv-broadband-phone.provider',
      metaTagOptions: { image: 'broadband' },
      product: 'broadband',
      providerBreadcrumbs: [['i18n/home', '/'], ['i18n/broadband', '/compare-tv-broadband-phone/']],
      searchPath: 'broadband/searches'
    },
    middleware: ['provider', 'products', 'breadcrumbs', 'jumbotron', 'meta-tags', 'providers'],
    computed: {
      ...mapGetters('providers', { provider: 'get' }),
      ...mapGetters('products', { bundles: 'getList' }),
      cheapest () {
        return orderBy(this.bundles, ['monthly_cost'])[0];
      },
      fastest () {
        return orderBy(this.bundles.filter(b => b.broadband), ['bb_download'], ['desc'])[0];
      }
    },
    mounted () {
      scrollToTop();
    },

    methods: {
      summaryBundle (bundleType) {
        return this[bundleType];
      }
    }
  };
